import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect'
import { Card, Row, Col } from "reactstrap";
import BannerCard from '../../../Components/BannerCard';
import api from "../../../../../../config";
let apiUrl = api[api.status].apiUrl;

function SelectedTemplatePage() {
  const dispatch = useDispatch();

  const selectTemplateState = createSelector(state => state, state => ({
    selectedTemplate: state.Campaign.selectedTemplate,
    uploadedFiles: state.Upload.uploadedFiles,
    filteredTemplateCreatives: state.Campaign.filteredTemplateCreatives
  }));
  const { selectedTemplate, uploadedFiles, filteredTemplateCreatives } = useSelector(selectTemplateState);

  return (
    <div className='w-100 d-flex flex-column'>
      <Row className='mt-2'>
        {Array.isArray(filteredTemplateCreatives) && filteredTemplateCreatives.map((item, idx) => {
          return (
            <Col lg={6} md={6} xs={12} key={idx}>
              <BannerCard idx={idx} templatePreview={item.templatePreview} figma={item.figma} figmaObject={item.figmaObject} type={'html'} size={item?.size} editableInFigmaPlugin={false} isCreativeCreated={false} showEdit={false} />
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
export default SelectedTemplatePage;